import { render, staticRenderFns } from "./TeacherInfoFeeArea.vue?vue&type=template&id=63e27330&scoped=true&"
import script from "./TeacherInfoFeeArea.vue?vue&type=script&lang=js&"
export * from "./TeacherInfoFeeArea.vue?vue&type=script&lang=js&"
import style0 from "./TeacherInfoFeeArea.vue?vue&type=style&index=0&id=63e27330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e27330",
  null
  
)

export default component.exports